var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	4784: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,20,3,27], () => (__webpack_require__.e(824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	6464: () => (loadStrictSingletonVersion("default", "@azure/msal-angular", false, [1,4,0,23], () => (__webpack_require__.e(653).then(() => (() => (__webpack_require__(/*! @azure/msal-angular */ 8653))))))),
	10501: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-header", false, [1,16,3,9], () => (__webpack_require__.e(185).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-header */ 4185))))))),
	24958: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,20,3,27], () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	43733: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,20,3,27], () => (__webpack_require__.e(55).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	44866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	46851: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-menu-v2", false, [1,16,3,9], () => (__webpack_require__.e(412).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-menu-v2 */ 34412))))))),
	49865: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-avatar", false, [1,16,3,9], () => (__webpack_require__.e(962).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-avatar */ 36581))))))),
	55549: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-footer", false, [1,16,3,9], () => (__webpack_require__.e(343).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-footer */ 3343))))))),
	75557: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-icon", false, [1,16,3,9], () => (__webpack_require__.e(162).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-icon */ 82781))))))),
	81267: () => (loadStrictSingletonVersion("default", "@azure/msal-browser", false, [1,4,27,0], () => (__webpack_require__.e(721).then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 74102))))))),
	84328: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,20,3,27], () => (__webpack_require__.e(691).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	91773: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-logo", false, [1,16,3,9], () => (__webpack_require__.e(112).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-logo */ 92731))))))),
	98773: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-stroke", false, [1,16,3,9], () => (__webpack_require__.e(437).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-stroke */ 25818))))))),
	32778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	12242: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,20,3,27], () => (__webpack_require__.e(867).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))))),
	99060: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,20,3,27], () => (__webpack_require__.e(70).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	20940: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,20,3,27], () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	11541: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-tooltip", false, [1,16,3,9], () => (__webpack_require__.e(564).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-tooltip */ 44183))))))),
	58205: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-helpers", false, [1,16,3,9], () => (__webpack_require__.e(770).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-helpers */ 90389))))))),
	59001: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-behaviors", false, [1,9,40,6], () => (__webpack_require__.e(591).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-behaviors */ 16591))))))),
	66645: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-link", false, [1,16,3,9], () => (__webpack_require__.e(281).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-link */ 76662))))))),
	3245: () => (loadStrictSingletonVersion("default", "@bancolombia/design-system-web/bc-badge", false, [1,16,3,9], () => (__webpack_require__.e(132).then(() => (() => (__webpack_require__(/*! @bancolombia/design-system-web/bc-badge */ 95751)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"20": [
		4784,
		6464,
		10501,
		24958,
		43733,
		44866,
		46851,
		49865,
		55549,
		75557,
		81267,
		84328,
		91773,
		98773
	],
	"31": [
		20940,
		24958,
		58205,
		59001,
		84328
	],
	"34": [
		20940,
		24958,
		32778,
		44866,
		81267,
		84328
	],
	"55": [
		4784,
		20940
	],
	"72": [
		20940,
		24958,
		32778,
		43733,
		44866
	],
	"132": [
		49865
	],
	"162": [
		58205
	],
	"183": [
		24958,
		59001
	],
	"185": [
		3245,
		11541,
		20940,
		58205,
		59001
	],
	"316": [
		24958,
		44866
	],
	"343": [
		20940,
		58205,
		59001,
		66645
	],
	"389": [
		24958
	],
	"412": [
		20940,
		58205,
		59001
	],
	"436": [
		4784,
		20940,
		24958
	],
	"443": [
		24958,
		32778,
		44866
	],
	"566": [
		3245,
		11541,
		20940,
		24958,
		58205,
		59001,
		75557,
		91773
	],
	"580": [
		12242,
		32778,
		44866,
		99060
	],
	"581": [
		11541,
		20940,
		24958,
		58205,
		59001
	],
	"653": [
		20940,
		32778
	],
	"662": [
		24958
	],
	"691": [
		20940,
		32778,
		43733,
		44866
	],
	"724": [
		20940,
		24958,
		58205,
		59001,
		66645,
		75557,
		84328,
		91773,
		98773
	],
	"731": [
		24958
	],
	"751": [
		20940,
		24958,
		49865,
		58205,
		59001,
		75557
	],
	"781": [
		24958,
		58205
	],
	"818": [
		24958
	],
	"824": [
		32778,
		44866
	],
	"935": [
		44866
	],
	"962": [
		11541,
		20940,
		58205,
		59001
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}